export const terms = [
  {
    id: 1,
    name: "주얼리",
    terms: ["주얼리 보관함"],
  },
  {
    id: 2,
    name: "귀걸이",
    terms: [
      "링귀걸이",
      "써지컬 귀걸이",
      "진주귀걸이",
      "14k 귀걸이",
      "투명귀걸이",
      "써지컬 링귀걸이",
      "드롭귀걸이",
      "귀걸이 세트",
      "은귀걸이",
      "실버귀걸이",
    ],
  },
  {
    id: 3,
    name: "목걸이",
    terms: [
      "써지컬 목걸이",
      "비즈목걸이",
      "y2k 목걸이",
      "진주목걸이",
      "빈티지 목걸이",
      "십자가 목걸이",
      "하트목걸이",
      "실버 목걸이",
      "비비안웨스트우드 목걸이",
      "원석 목걸이",
    ],
  },
  {
    id: 4,
    name: "반지",
    terms: [
      "커플반지",
      "우정반지",
      "반지갑",
      "써지컬 반지",
      "각인반지",
      "실반지",
      "은반지",
      "반지세트",
      "비즈반지",
      "실버반지",
    ],
  },
  {
    id: 5,
    name: "팔찌",
    terms: [
      "커플팔찌",
      "비즈팔찌",
      "써지컬 팔찌",
      "우정팔찌",
      "실팔찌",
      "각인팔찌",
      "소원팔찌",
      "체인팔찌",
      "원석팔찌",
      "매듭팔찌",
    ],
  },
  {
    id: 6,
    name: "발찌",
    terms: ["14k발찌"],
  },
  {
    id: 7,
    name: "보석함",
    terms: ["보석 컬렉션", "정보석"],
  },
  {
    id: 8,
    name: "귀",
    terms: [
      "귀찌",
      "링귀걸이",
      "먼작귀",
      "써지컬 귀걸이",
      "진주귀걸이",
      "14k 귀걸이",
      "귀여운",
      "귀마개",
      "귀도리",
      "귀여운 옷",
    ],
  },
  {
    id: 9,
    name: "걸",
    terms: [
      "써지컬 목걸이",
      "링귀걸이",
      "당당걸",
      "비즈목걸이",
      "y2k 목걸이",
      "모리걸",
      "진주목걸이",
      "써지컬 귀걸이",
      "빈티지 목걸이",
      "육육걸즈",
    ],
  },
  {
    id: 10,
    name: "이",
    terms: [
      "아이폰 케이스",
      "에어팟케이스",
      "와이드팬츠",
      "아이패드 케이스",
      "이윤주",
      "트레이닝바지",
      "와이드 청바지",
      "나이키",
      "핸드폰케이스",
      "맥세이프 카드지갑",
      "트레이닝 세트",
    ],
  },
  {
    id: 11,
    name: "목",
    terms: [
      "목도리",
      "손목시계",
      "목티",
      "써지컬 목걸이",
      "목폴라",
      "비즈목걸이",
      "y2k 목걸이",
      "발목양말",
      "진주목걸이",
      "빈티지 목걸이",
    ],
  },
  {
    id: 12,
    name: "반",
    terms: [
      "반바지",
      "반팔",
      "반팔티",
      "반팔니트",
      "청반바지",
      "반팔셔츠",
      "골반뽕",
      "오버핏 반팔",
      "트레이닝 반바지",
      "골반뽕 청바지",
    ],
  },
  {
    id: 13,
    name: "지",
    terms: [
      "청바지",
      "반바지",
      "아디다스 져지",
      "트레이닝바지",
      "와이드 청바지",
      "져지",
      "카드지갑",
      "지비츠",
      "맥세이프 카드지갑",
      "카고바지",
    ],
  },
  {
    id: 14,
    name: "팔",
    terms: [
      "반팔",
      "반팔티",
      "긴팔",
      "긴팔티",
      "반팔니트",
      "반팔셔츠",
      "얇은 긴팔",
      "긴팔티셔츠",
      "커플팔찌",
      "오버핏 반팔",
    ],
  },
  {
    id: 15,
    name: "찌",
    terms: [
      "커플팔찌",
      "귀찌",
      "비즈팔찌",
      "써지컬 팔찌",
      "우정팔찌",
      "실팔찌",
      "각인팔찌",
      "소원팔찌",
      "구찌",
      "체인팔찌",
    ],
  },
  {
    id: 16,
    name: "발",
    terms: [
      "아디다스 신발",
      "발레코어",
      "나이키 신발",
      "가발",
      "뉴발란스",
      "샥출발",
      "발목양말",
      "언발 오프숄더",
      "겨울신발",
      "가을신발",
    ],
  },
  {
    id: 17,
    name: "보",
    terms: [
      "보부상가방",
      "아이폰 보조배터리",
      "사생활보호필름",
      "키보드",
      "보부상",
      "보정속옷",
      "다이어트 보조제",
      "아이폰 사생활보호필름",
      "아이패드 키보드",
      "호보백",
    ],
  },
  {
    id: 18,
    name: "석",
    terms: [
      "석관동 떡볶이",
      "원석 목걸이",
      "보석십자수",
      "원석팔찌",
      "추석",
      "자석귀찌",
      "탄생석 팔찌",
      "추석선물",
      "의자방석",
      "탄생석 반지",
      "탄생석 목걸이",
    ],
  },
  {
    id: 19,
    name: "함",
    terms: [
      "화장품 정리함",
      "정리함",
      "악세사리 보관함",
      "보관함",
      "수납함",
      "화장대 정리함",
      "cd 보관함",
      "피규어 보관함",
      "책상정리함",
      "명함지갑",
    ],
  },
];
